import React, { useState, useRef, useEffect } from 'react';
import {
  PassReviewModifyContainer,
  PassReviewModifyTitle,
  FormContainer,
  ButtonContainer,
} from './style';

import { useMutation } from 'react-query';
import { modifyProfessorQna } from '../../axiosManage/Professor';

import Input from '../../components/atoms/Input';
import { Button, CancelButton } from '../../components/atoms/Button/index';
import ToastEditor from '../../components/atoms/ToastTextEditor';
import Select from '../../components/atoms/Select';
import COLOR from '../../styles/common/color';

import { modifyReview } from '../../axiosManage/Professor';
import useHandleError from '../../hooks/useHandleError';
import { useRecoilValue, useRecoilState } from 'recoil';
import { isLoginAtom } from '../../recoil/AuthStore/AuthRecoil';
import { myInfoAtom, myContactAtom, myReviewId } from '../../recoil/MyPageStore/MyPageRecoil';

import { useNavigate, Navigate } from 'react-router-dom';

function ReviewModifyPage() {
  const { handleError } = useHandleError();
  const editorRef = useRef();
  const navigate = useNavigate();
  const myInfo = useRecoilValue(myInfoAtom);
  const isLogin = useRecoilValue(isLoginAtom);

  if (isLogin === false) {
    alert('로그인을 해주세요.');
    return <Navigate to="/login" />;
  }

  const [ReviewContent, setReviewContent] = useRecoilState(myContactAtom);
  const [ReviewId, setReviewContentId] = useRecoilState(myReviewId);

  const SELECT_OPTIONS = [
    { value: ReviewContent.lectureName, optionName: ReviewContent.lectureName },
  ];

  // 유저가 입력한 서버로 전송할 데이터(제목, 내용, 카테고리)
  const [title, setTitle] = useState(ReviewContent.title);
  //const [category, setCategory] = useState(ReviewContent.category);

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  // const handleCategoryChange = (e) => {
  //   setCategory(e.target.value);
  // };

  /** 수강후기 글 전송 로직 */
  const postModifyPassReview = useMutation(
    (data) => {
      modifyReview(ReviewId, data);
    },
    {
      onSuccess: () => {
        alert('수정이 완료되었습니다!');
        navigate(-1);
      },
      onError: (error) => {
        alert('수정에 실패했습니다.');
        handleError(error);
      },
    },
  );

  const modifySubmit = () => {
    const data = {
      title: title,
      content: editorRef.current?.getInstance().getHTML(),
    };

    if (
      data.title !== '' &&
      !data.content.includes('위에 구분을 먼저 선택 후 글을 작성해주시기 바랍니다!') &&
      data.category !== '구분'
    ) {
      postModifyPassReview.mutate(data);
    } else {
      alert('제목, 내용, 카테고리를 모두 입력해주세요!');
    }
  };

  const modifyCancel = () => {
    let isYes = confirm('수정을 취소하시겠습니까?');

    if (isYes) {
      alert('수정을 취소하셨습니다.');
      navigate(-1);
    }
  };

  return (
    <PassReviewModifyContainer>
      <PassReviewModifyTitle>
        수강후기
        <p>수강후기 수정하기</p>
      </PassReviewModifyTitle>
      <FormContainer>
        <div>
          <Select
            width={313}
            height={58}
            selectOptions={SELECT_OPTIONS}
            //onChangeFunc={handleCategoryChange}
          />
          <Input
            width={645}
            height={58}
            placeholder="제목을 입력하세요."
            defaultValue={title}
            onChangeFunc={handleTitleChange}
          />
          {isLogin ? (
            <div>이름: {myInfo.name}</div>
          ) : (
            <Input width={313} height={58} placeholder="이름을 입력하세요." />
          )}
        </div>
        <ToastEditor editorRef={editorRef} content={ReviewContent.content} />
        <div>
          <ButtonContainer>
            <div>
              <CancelButton
                width={124}
                height={48}
                bgColor={COLOR.BLUE_4}
                onClickFunc={() => modifyCancel()}
              >
                취소
              </CancelButton>
              <Button width={124} height={48} bgColor={COLOR.BLUE_4} onClickFunc={modifySubmit}>
                수정하기
              </Button>
            </div>
          </ButtonContainer>
        </div>
      </FormContainer>
    </PassReviewModifyContainer>
  );
}

export default ReviewModifyPage;
